import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Icon from 'components/Utils/NewIcon';
import DefaultButton from 'components/Utils/NewDefaultButton';
import ProgressMessage from 'components/Utils/ProgressMessage';
import './style.scss';

const UploadFile = (props) => {
  const [submitting, setSubmitting] = useState(false);
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState();

  async function submit() {
    if (props.onSubmit !== undefined) {
      setSubmitting(true);
      let status = await props.onSubmit(file);
      setSubmitting(false);
      if (status === true) deleteLocalFiles();
    }
  }

  function onDrop(acceptedFiles, rejectedFiles) {
    if (!props.loading) {
      setFile(acceptedFiles[0]);
      setFiles([...files, ...acceptedFiles]);

      if (props.onDrop !== undefined) props.onDrop(acceptedFiles[0]);
    }
  }

  function deleteLocalFiles() {
    (files || []).forEach((file) => {
      window.URL.revokeObjectURL(file.preview);
    });
    setFile(undefined);
    setFiles([]);
  }

  let width = props.width || '70px';
  let height = props.height || '70px';
  let outline = '2px dashed rgba(0,0,0,0.5)';

  let preview = (
    <div style={{ height: '100%', display: 'flex' }}>
      <Icon src="upload" width="25px" />
    </div>
  );

  if (file !== undefined) {
    if (file.type === 'application/pdf') {
      preview = (
        <div style={{ height: '100%', display: 'flex' }}>
          <Icon src="file-pdf" />
        </div>
      );
    } else {
      preview = <img width="100%" src={file.preview} alt={file.preview} />;
    }
    outline = '';
  }

  if (props.loading) {
    preview = (
      <div className="loading-wrapper">
        <ProgressMessage />
      </div>
    );
  }

  return (
    <div className="upload-photo">
      {props.title && <span className="small-title">{props.title}</span>}
      <Dropzone
        style={{
          margin: '10px 10px 10px 0',
          minHeight: height,
          width,
          height,
          background: 'var(--color-bg-muted)',
          outline: outline,
          outlineOffset: '-10px',
        }}
        disabled={props.loading}
        accept={props.accept}
        multiple={false}
        onDrop={onDrop}
      >
        {preview}
      </Dropzone>
      {!!props.onSubmit && (
        <div className="button-wrapper">
          <DefaultButton
            name="Submit"
            onClick={submit}
            loading={submitting}
            disabled={props.disabled || !file || props.loading}
            style={{ width: '150px' }}
            hide={props.hideButton === true}
          />
        </div>
      )}
    </div>
  );
};

UploadFile.propTypes = {
  onSubmit: PropTypes.func,
  onDrop: PropTypes.func,
  title: PropTypes.string,
  accept: PropTypes.string,
  hideButton: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  loading: PropTypes.bool,
};

UploadFile.defaultProps = {
  accept: 'image/jpeg, image/png',
  title: 'Upload Image',
};

export default UploadFile;
